import dynamic from 'next/dynamic';

const PDFDoc = dynamic(() => import('./PDFDoc'), { ssr: false });

export default PDFDoc;
